/* =========================================================
   Affiche TENNIS DE TABLE « L'aire de jeu » — la table, l'échange, le double.
   API : SNTTTable.render(data, opts) -> string SVG
     data : { mode, titre, kicker, club, lieu, joueur, date,
              sport   : 'tennis-de-table' | 'badminton' | 'padel'
              mode 'table'   → s1..s3 (« valeur|libellé ») ; sinon les cotes officielles
              mode 'echange' → echanges (3 à 30), score, resultat
              mode 'double'  → j1, j2 (« Prénom|points »), titreDouble }
     opts : { palette }

   La géométrie de l'aire de jeu est PARAMÉTRÉE (map AIRES) : la même fonction
   dessine la table de tennis de table, le terrain de badminton et la piste de
   padel. Ajouter un sport de raquette = une entrée dans AIRES.

   La trajectoire de l'échange est tirée d'un générateur DÉTERMINISTE amorcé
   par les données saisies : même saisie → même dessin, à l'écran comme à
   l'impression. Aucun aléa réel, sinon l'aperçu et le fichier print
   divergeraient.

   Auto-suffisant (aucun fetch, aucune image) → re-render serveur direct.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    craie: { label:'Craie',      bg:'#F7F4ED', ink:'#0B2D5B', muted:'#8B94A3', accent:'#FF6B2C', line:'#E3DDD0', card:'#FFFFFF', table:'#1F4E8C', deep:'#12365F' },
    bleu:  { label:'Bleu salle', bg:'#0E2A4A', ink:'#F4F1E8', muted:'#8FA6BF', accent:'#FF6B2C', line:'#1C4470', card:'#15355C', table:'#1F4E8C', deep:'#0A1F38' },
    vert:  { label:'Vert table', bg:'#10362C', ink:'#F4F1E8', muted:'#8FB3A5', accent:'#FF6B2C', line:'#1C5544', card:'#164536', table:'#1B5E4A', deep:'#0B271F' },
    nuit:  { label:'Nuit',       bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', table:'#123E70', deep:'#082444' },
  };

  /* Cotes réelles de chaque aire de jeu.
       ratio        = longueur / largeur
       centre       = [début, fin] de la ligne médiane, en fraction de la DEMI-longueur
                      mesurée depuis le filet (0 = filet, 1 = ligne de fond)
       couloirs     = lignes longitudinales, en fraction de la largeur
       transversales= lignes parallèles au filet, en fraction de la demi-longueur
       filet        = débordement du filet de CHAQUE côté, en fraction de la largeur
       echanges     = mot employé pour une frappe : la balle rebondit au ping et
                      au padel, le volant JAMAIS

     Tennis de table : filet de 1,83 m pour une table de 1,525 m → 15,25 cm
     dépassent de chaque côté, soit 10 %. Ligne médiane sur toute la longueur.
     Badminton : ligne de service court à 1,98 m du filet, ligne de fond de
     service en double à 0,76 m de la ligne de fond ; la médiane ne court QUE
     du service court au fond. Filet arrêté aux limites du terrain.
     Padel : ligne de service à 3 m du filet, médiane du filet à cette ligne. */
  const AIRES = {
    'tennis-de-table': { ratio: 2.74 / 1.525, centre: [0, 1], couloirs: [], transversales: [], filet: 0.10, projectile: 'balle-orange',
      echanges: 'échanges', cotes: [['2,74 m','Longueur'], ['1,525 m','Largeur'], ['15,25 cm','Filet']] },
    'badminton': { ratio: 13.4 / 6.1, centre: [1.98 / 6.7, 1], couloirs: [0.075, 0.925], transversales: [1.98 / 6.7, (6.7 - 0.76) / 6.7], filet: 0, projectile: 'volant',
      echanges: 'frappes', cotes: [['13,40 m','Longueur'], ['6,10 m','Largeur'], ['1,55 m','Filet']] },
    'padel': { ratio: 20 / 10, centre: [0, 0.30], couloirs: [], transversales: [0.30], vitres: true, filet: 0, projectile: 'balle-jaune',
      echanges: 'échanges', cotes: [['20 m','Longueur'], ['10 m','Largeur'], ['0,88 m','Filet']] },
  };

  /* Encombrement réservé à l'aire de jeu selon le mode. La largeur est DÉDUITE
     du ratio du sport : sans cela, un terrain de badminton (ratio 2,20 contre
     1,80 pour la table) dessiné à la même largeur déborderait sur le bandeau
     du bas. Le plafond `largMax` garde la table de ping-pong au pixel près. */
  const BOITES = {
    table:   { lng: 539, largMax: 300 },
    echange: { lng: 539, largMax: 300 },
    double:  { lng: 449, largMax: 250 },
  };
  const largeurAire = (mode, ratio) => Math.min(BOITES[mode].largMax, BOITES[mode].lng / ratio);

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };

  function stats(p, items, y, x0) {
    x0 = x0 || 54;
    const it = items.filter(x => String(x[0] || '').trim());
    if (!it.length) return '';
    const w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      s += T(cc, y+6, fit(c[0], w-24, 38, 0.56, 0, 17), p.ink, esc(c[0]), { f:'Oswald', w:700 })
        + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }

  /** L'aire de jeu, vue de dessus. cy = centre du filet. */
  function aire(sportId, cx, cy, larg, p) {
    const a = AIRES[sportId] || AIRES['tennis-de-table'];
    const lng = larg * a.ratio;
    const x = cx - larg / 2, y = cy - lng / 2;
    const L = '#FFFFFF', sw = Math.max(2.5, larg * 0.009), h = sw / 2;
    let g = `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${larg.toFixed(1)}" height="${lng.toFixed(1)}" fill="${p.table}"/>`;
    /* Bordure tracée EN DEDANS : sur fond clair, la moitié extérieure d'un
       trait blanc centré disparaîtrait dans le fond. */
    g += `<rect x="${(x+h).toFixed(1)}" y="${(y+h).toFixed(1)}" width="${(larg-sw).toFixed(1)}" height="${(lng-sw).toFixed(1)}" fill="none" stroke="${L}" stroke-width="${sw}"/>`;
    /* La ligne médiane est SYMÉTRIQUE de part et d'autre du filet, et ne court
       pas forcément sur toute la longueur (au badminton elle s'arrête au
       service court, au padel elle s'arrête à la ligne de service). */
    const demi = lng / 2;
    if (a.centre) {
      const [d0, d1] = a.centre;
      for (const sens of [-1, 1]) {
        const ya = cy + sens * (d0 * demi), yb = cy + sens * Math.min(d1 * demi, demi - sw);
        g += `<line x1="${cx}" y1="${ya.toFixed(1)}" x2="${cx}" y2="${yb.toFixed(1)}" stroke="${L}" stroke-width="${sw*0.8}" opacity="0.9"/>`;
      }
    }
    for (const f of a.couloirs) g += `<line x1="${(x+larg*f).toFixed(1)}" y1="${(y+sw).toFixed(1)}" x2="${(x+larg*f).toFixed(1)}" y2="${(y+lng-sw).toFixed(1)}" stroke="${L}" stroke-width="${sw*0.8}" opacity="0.75"/>`;
    /* Lignes de service, parallèles au filet, également symétriques. */
    for (const f of (a.transversales || [])) for (const sens of [-1, 1]) {
      const yy = cy + sens * f * demi;
      g += `<line x1="${(x+sw).toFixed(1)}" y1="${yy.toFixed(1)}" x2="${(x+larg-sw).toFixed(1)}" y2="${yy.toFixed(1)}" stroke="${L}" stroke-width="${sw*0.8}" opacity="0.75"/>`;
    }
    if (a.vitres) g += `<rect x="${(x-larg*0.04).toFixed(1)}" y="${(y-larg*0.04).toFixed(1)}" width="${(larg*1.08).toFixed(1)}" height="${(lng+larg*0.08).toFixed(1)}" rx="4" fill="none" stroke="${L}" stroke-width="${sw*0.9}" opacity="0.38"/>`;
    /* Le filet, avec le débordement réglementaire du sport concerné. */
    const dep = a.filet == null ? 0.10 : a.filet;
    const dy = larg * 0.055, nx = x - larg * dep, nw = larg * (1 + 2 * dep);
    g += `<rect x="${nx.toFixed(1)}" y="${(cy-dy/2).toFixed(1)}" width="${nw.toFixed(1)}" height="${dy.toFixed(1)}" fill="${p.deep}"/>`;
    for (let i = 1; i < 16; i++) g += `<line x1="${(nx+nw*i/16).toFixed(1)}" y1="${(cy-dy/2).toFixed(1)}" x2="${(nx+nw*i/16).toFixed(1)}" y2="${(cy+dy/2).toFixed(1)}" stroke="${L}" stroke-width="1" opacity="0.28"/>`;
    g += `<rect x="${nx.toFixed(1)}" y="${(cy-dy/2).toFixed(1)}" width="${nw.toFixed(1)}" height="${(dy*0.24).toFixed(1)}" fill="${L}" opacity="0.95"/>`;
    return g;
  }

  /** Le projectile du sport. Ce sont des couleurs d'OBJET, pas de thème :
      elles ne suivent pas la palette. Une balle orange sur un terrain de
      badminton serait vue immédiatement comme une erreur. */
  function projectile(cx, cy, r, type) {
    if (type === 'volant') {
      /* Volant posé bouchon en bas, jupe évasée vers le haut : la silhouette
         que tout le monde reconnaît. */
      const b = r * 0.62;                       /* rayon du bouchon de liège */
      const hj = r * 1.75, lj = r * 1.02;       /* hauteur et demi-largeur de la jupe */
      let g = `<path d="M${(cx-b).toFixed(1)} ${(cy-b*0.15).toFixed(1)} L${(cx-lj).toFixed(1)} ${(cy-hj).toFixed(1)} L${(cx+lj).toFixed(1)} ${(cy-hj).toFixed(1)} L${(cx+b).toFixed(1)} ${(cy-b*0.15).toFixed(1)} Z" fill="#F7F4ED"/>`;
      for (let i = 1; i < 5; i++) {
        const t = i / 5;
        g += `<line x1="${(cx - b + 2*b*t).toFixed(1)}" y1="${(cy-b*0.15).toFixed(1)}" x2="${(cx - lj + 2*lj*t).toFixed(1)}" y2="${(cy-hj).toFixed(1)}" stroke="#B9BFC9" stroke-width="${(r*0.075).toFixed(2)}"/>`;
      }
      g += `<line x1="${(cx-lj*0.62).toFixed(1)}" y1="${(cy-hj*0.58).toFixed(1)}" x2="${(cx+lj*0.62).toFixed(1)}" y2="${(cy-hj*0.58).toFixed(1)}" stroke="#B9BFC9" stroke-width="${(r*0.075).toFixed(2)}"/>`;
      g += `<path d="M${(cx-b).toFixed(1)} ${(cy-b*0.15).toFixed(1)} a ${b} ${b} 0 0 0 ${(b*2).toFixed(1)} 0 Z" fill="#E8DCC4"/>`;
      return g;
    }
    const teinte = type === 'balle-jaune' ? '#D8E63C' : '#F5A623';
    return `<circle cx="${cx.toFixed(1)}" cy="${cy.toFixed(1)}" r="${r}" fill="${teinte}"/>`
      + `<path d="M${(cx-r).toFixed(1)} ${cy.toFixed(1)} a ${r} ${r} 0 0 0 ${r*2} 0" fill="none" stroke="#00000022" stroke-width="${(r*0.10).toFixed(2)}"/>`
      + `<circle cx="${(cx-r*0.32).toFixed(1)}" cy="${(cy-r*0.34).toFixed(1)}" r="${(r*0.20).toFixed(1)}" fill="#ffffff" opacity="0.45"/>`;
  }

  /* Générateur déterministe : la même saisie doit produire exactement le même
     échange à l'écran et sur le fichier d'impression. */
  function graine(s) { let h = 2166136261; s = String(s); for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function tirage(seed) { let s = (seed || 1) >>> 0; return function () { s = (Math.imul(s, 1664525) + 1013904223) >>> 0; return s / 4294967296; }; }

  /* Le troisième chiffre du bandeau n'a pas le même nom selon le sport : des
     points au ping, une série de classement au badminton, un rang au padel.
     Dérivé de `sport`, déjà présent dans _perso : aucun câblage supplémentaire. */
  const LIB_POINTS = { badminton: 'Classement', padel: 'Mon rang' };

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const mode = String(data.mode || 'table').toLowerCase();
    const sportId = AIRES[data.sport] ? data.sport : 'tennis-de-table';
    const aireDef = AIRES[sportId];
    const cx = PW / 2;

    const DEF = { table: 'LA TABLE', echange: 'L ÉCHANGE', double: 'NOTRE DOUBLE' };
    const titre = up(data.titre) || DEF[mode] || 'LA TABLE';
    const ts = fit(titre, 690, 74, 0.54, 2, 32);
    const kicker = up(data.kicker) || up(data.club) || 'TENNIS DE TABLE';
    const sous = [up(data.club), up(data.lieu)].filter(Boolean).join(' · ');

    let corps = '', barre = '', pied = '';

    if (mode === 'echange') {
      /* Un rebond par échange. Au-delà de 30 le dessin devient illisible :
         on borne, et le libellé affiche le nombre réellement dessiné. */
      const n = Math.max(3, Math.min(30, Math.round(num(data.echanges) || 12)));
      const cy = 592, larg = largeurAire('echange', aireDef.ratio), lng = larg * aireDef.ratio, y0 = cy - lng / 2;
      const r = tirage(graine([data.joueur, data.date, data.score, n].join('|')));
      const pts = [];
      let prevX = 0;
      for (let i = 0; i < n; i++) {
        /* Les rebonds alternent de part et d'autre du filet. */
        const haut = i % 2 === 1;
        const fy = haut ? 0.09 + r() * 0.28 : 0.63 + r() * 0.28;
        let fx = -0.34 + r() * 0.68;
        if (Math.abs(fx - prevX) < 0.16) fx = fx > 0 ? fx - 0.22 : fx + 0.22;
        prevX = fx;
        pts.push([cx + fx * larg, y0 + fy * lng]);
      }
      corps = aire(sportId, cx, cy, larg, p);
      /* Vue de dessus : entre deux rebonds la balle va tout droit. L'arc ne se
         voit que de profil — le dessiner ici serait faux. */
      /* Segment par segment, de plus en plus opaque : au-delà d'une quinzaine
         d'échanges un tracé uniforme devient un gribouillis illisible. Le
         dégradé rend le SENS de lecture évident et fait ressortir la fin du
         point, qui est le sujet de l'affiche. */
      for (let i = 1; i < pts.length; i++) {
        const op = (0.20 + 0.78 * (i / (pts.length - 1))).toFixed(2);
        corps += `<line x1="${pts[i-1][0].toFixed(1)}" y1="${pts[i-1][1].toFixed(1)}" x2="${pts[i][0].toFixed(1)}" y2="${pts[i][1].toFixed(1)}" stroke="${p.accent}" stroke-width="3" stroke-linecap="round" stroke-dasharray="10 9" opacity="${op}"/>`;
      }
      pts.forEach((c, i) => {
        const last = i === pts.length - 1;
        if (last) corps += `<circle cx="${c[0].toFixed(1)}" cy="${c[1].toFixed(1)}" r="15" fill="${p.accent}" opacity="0.22"/>`;
        const op = last ? 1 : (0.16 + 0.44 * (i / (pts.length - 1))).toFixed(2);
        corps += `<circle cx="${c[0].toFixed(1)}" cy="${c[1].toFixed(1)}" r="${last ? 6 : 4.5}" fill="${last ? p.accent : '#FFFFFF'}" opacity="${op}"/>`;
      });
      corps += projectile(cx + 0.30 * larg, y0 - 34, 16, aireDef.projectile);
      /* esc() sur TOUTE la légende : `resultat` est une saisie libre, un « & »
         ou un « < » y produirait un SVG XML invalide, donc aucun fichier
         d'impression. */
      /* « échanges » au ping et au padel, « frappes » au badminton : le volant
         ne rebondit pas, parler de rebond y serait faux. */
      const legende = esc([n + ' ' + up(aireDef.echanges || 'échanges'), up(data.resultat), up(data.score)].filter(Boolean).join(' · '));
      corps += T(cx, cy + lng / 2 + 62, 15, p.accent, legende, { w:700, ls:4 });
      barre = stats(p, [[data.points, LIB_POINTS[data.sport] || 'Mes points'], [data.division, 'Division'], [data.club, 'Club']], 968);

    } else if (mode === 'double') {
      const cy = 578, larg = largeurAire('double', aireDef.ratio), lng = larg * aireDef.ratio;
      corps = aire(sportId, cx, cy, larg, p) + projectile(cx + larg * 0.31, cy - lng / 2 - 30, 15, aireDef.projectile);
      const j = [];
      for (let i = 1; i <= 2; i++) {
        const raw = String(data['j' + i] || '').trim(); if (!raw) continue;
        const [nom, pts] = raw.split('|').map(s => (s || '').trim());
        if (nom) j.push([nom, pts]);
      }
      if (j.length) {
        const gap = 16, w = (PW - 2 * MX - gap * (j.length - 1)) / j.length;
        j.forEach((c, i) => {
          const x = MX + i * (w + gap), cc = x + w / 2;
          corps += `<rect x="${x.toFixed(1)}" y="826" width="${w.toFixed(1)}" height="96" rx="14" fill="${p.card}"/>`
            + T(cc, 866, fit(c[0], w - 28, 28, 0.60, 1, 15), p.ink, esc(up(c[0])), { f:'Oswald', w:700, ls:1 })
            + (c[1] ? T(cc, 896, 13, p.muted, esc(up(c[1])), { w:600, ls:2 }) : '');
        });
      }
      if (data.titreDouble) pied = T(cx, 990, 15, p.accent, esc(up(data.titreDouble)), { w:700, ls:4 });

    } else { /* table */
      const cy = 620, larg = largeurAire('table', aireDef.ratio), lng = larg * aireDef.ratio;
      corps = aire(sportId, cx, cy, larg, p) + projectile(cx + 108, cy - lng / 2 - 44, 17, aireDef.projectile);
      /* Cotes officielles par défaut, remplaçables champ par champ. */
      const perso = [1, 2, 3].map(i => {
        const raw = String(data['s' + i] || '').trim();
        if (!raw) return null;
        const [v, l] = raw.split('|').map(s => (s || '').trim());
        return v ? [v, l || ''] : null;
      });
      barre = stats(p, perso.some(Boolean) ? perso.filter(Boolean) : aireDef.cotes, 968);
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, fit(sous, 660, 17, 0.66, 3.5, 11), p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${corps}
${barre}
${pied}
${data.joueur && mode !== 'double' ? T(cx, 1030, 14, p.muted, esc(up(data.joueur)), { w:600, ls:4 }) : ''}
</svg>`;
  }

  window.SNTTTable = { render, PALETTES, AIRES };
})();
